import React from "react";

interface CheckboxPropType {
  label?: string;
  checked?: boolean;
  required?: boolean;
  disabled?: boolean;
  id?: string;
  name?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  isDarkBg?: boolean;
}

const Checkbox = ({
  label,
  required,
  checked = false,
  disabled = false,
  onChange = undefined,
  name = "",
  id = "",
  isDarkBg = false,
}: CheckboxPropType) => {
  return (
    <div className="flex justify-start items-center cursor-pointer">
      <input
        type="checkbox"
        onChange={onChange}
        checked={checked}
        name={name}
        id={id}
        disabled={disabled}
        style={disabled ? { cursor: "not-allowed" } : {}}
        className={`cursor-pointer rounded shadow-none border-docsigna-blue-dark ${isDarkBg ? "bg-docsigna-pink-light" : ""}`}
      />
      {label && (
        <label htmlFor={id} className="cursor-pointer text-base ml-2" style={disabled ? { cursor: "not-allowed" } : {}}>
          {label} {required ? <span className="text-red-500">*</span> : null}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
